import { Email, HomeWork, Place, WhatsApp } from '@mui/icons-material'
import { Card, CardContent, Container, Grid } from '@mui/material'
import ArgonBox from 'components/ArgonBox'
import ArgonTypography from 'components/ArgonTypography'
import React from 'react'

const Kontak = () => {
    return (
        <Container sx={{ my: 10 }}>
            <ArgonBox mt={2}>
                <Grid container spacing={2} my={2}>
                    <Grid item xs={12} xl={12}>
                        <ArgonTypography>KONTAK</ArgonTypography>
                    </Grid>
                </Grid>
            </ArgonBox>
            <ArgonBox mt={2}>
                <Card>
                    <CardContent>
                        <Grid container spacing={2} mt={1}>
                            <Grid item xs={12} xl={6}>
                                <iframe
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d914.4675403105786!2d122.87380580609594!3d-5.516031653741355!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2da40fc055f692e1%3A0xa281f2aeb65178b7!2sFVMF%2BH85%2C%20Dongkala%2C%20Kec.%20Ps.%20Wajo%2C%20Kabupaten%20Buton%2C%20Sulawesi%20Tenggara%2093754!5e1!3m2!1sid!2sid!4v1757618613317!5m2!1sid!2sid"
                                    width="600"
                                    height="450"
                                    allowfullscreen=""
                                    loading="lazy"
                                    referrerpolicy="no-referrer-when-downgrade"
                                >
                                </iframe>
                            </Grid>
                            <Grid item xs={12} xl={6}>
                                <ArgonTypography variant="h3">
                                    TIM EVALUASI PENGENDALIAN DAN PENGAWASAN REALISASI ANGGARAN
                                </ArgonTypography>
                                <ArgonTypography mt={6}>
                                    <HomeWork/> Bagian Administrasi Pembangunan
                                </ArgonTypography>
                                <ArgonTypography mt={3}>
                                    <Place/> Kompleks Perkantoran Takawa Gedung D Lt. 2
                                </ArgonTypography>
                                <ArgonTypography mt={3}>
                                    <Email/> pembangunan@butonkab.go.id
                                </ArgonTypography>
                                <ArgonTypography mt={3}>
                                    <WhatsApp/> +62 85255412096
                                </ArgonTypography>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </ArgonBox>
        </Container>
    )
}

export default Kontak

